module["exports"] = [
  "المملكة العربية السعودية"
];
